import { NavLink, useLocation } from 'react-router-dom';
import { Home, BookOpen, BarChart3, User, CreditCard } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { useT } from '../lib/i18n';

export default function BottomNav() {
  const { uiLang, navBlocker } = useApp();
  const t = useT(uiLang);
  const loc = useLocation();
  const items = [
    { to: '/home', icon: Home, label: t('home'), testid: 'nav-home' },
    { to: '/books', icon: BookOpen, label: t('books'), testid: 'nav-books' },
    { to: '/dashboard', icon: BarChart3, label: t('dashboard'), testid: 'nav-dashboard' },
    { to: '/billing', icon: CreditCard, label: 'Billing', testid: 'nav-billing' },
    { to: '/profile', icon: User, label: t('profile'), testid: 'nav-profile' },
  ];

  // Iter-51.42 — ask the registered guard (Quiz.jsx during a live
  // round) before leaving. If the guard returns true, block the tap
  // so Quiz can pop its Stay/Leave modal. Same-route taps are always
  // fine (no navigation happens).
  const guard = (to) => (e) => {
    if (loc.pathname === to) return;
    if (typeof navBlocker === 'function' && navBlocker(to)) {
      e.preventDefault();
    }
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t-2 border-slate-100 pb-[max(0.5rem,env(safe-area-inset-bottom))] pt-2 px-3 sm:px-6 flex justify-around items-center z-40 rounded-t-3xl shadow-[0_-10px_40px_rgba(0,0,0,0.05)]">
      {items.map(({ to, icon: Icon, label, testid }) => (
        <NavLink data-testid={testid} key={to} to={to} onClick={guard(to)} className={({ isActive }) =>
          `flex flex-col items-center gap-1 py-2 px-2 sm:px-4 min-w-[50px] ${isActive ? 'text-[#FF6B1A] scale-110' : 'text-slate-400 hover:text-slate-600'} transition-all`
        }>
          <Icon size={24} strokeWidth={3} />
          <span className="text-[11px] sm:text-xs font-bold">{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
